import { fetchUserInfo } from 'App/api/userApi';
import { tokenDuck } from '../../store/jwtMiddleware';
import { USER_ROLES } from '../domain/user';
import { creators as organizationCreators } from '../ducks/organizationDuck';
import { creators as userCreators } from '../ducks/userDuck';
import { getConfigurationAction } from './configuration';

const YEAR_MILLIS = 31556952000;

const createDateYearFromNow = () => new Date(Date.now() + YEAR_MILLIS).toString();

const mapOrganization = user => {
  return {
    organizationId: user.roles[0].organizationId,
    organizationName: user.roles[0].organizationDetails.name,
    organizationShortName: user.roles[0].organizationDetails.shortName,
    managementApiEnabled: true,
  };
};

const rolePriority = [
  USER_ROLES.ADMIN,
  USER_ROLES.DEPLOYER,
  USER_ROLES.OPERATOR,
  USER_ROLES.MONITOR,
  USER_ROLES.BILLING,
  USER_ROLES.AGENT,
];

const compareRoles = (role1, role2) => {
  if (rolePriority.indexOf(role1.role) < rolePriority.indexOf(role2.role)) {
    return 1;
  } else if (rolePriority.indexOf(role1.role) > rolePriority.indexOf(role2.role)) {
    return -1;
  }
  return 0;
};

const fetchCookieUser = async () => {
  const user = await fetchUserInfo();
  return {
    userId: user.userId,
    name: user.userName,
    email: '',
    organizationId: user.roles[0]?.organizationShortName,
    roles: user.roles
      .map(role => ({
        role: role.role,
        userId: user.userId,
        organizationId: role.organizationShortName,
        organizationDetails: {
          name: role.organizationShortName,
          shortName: role.organizationShortName,
        },
      }))
      .reduce((acc, role) => {
        const existingRole = acc.find(r => r.organizationId === role.organizationId);
        if (existingRole) {
          if (compareRoles(existingRole, role) > 0) {
            return acc;
          } else if (compareRoles(existingRole, role) < 0) {
            existingRole.role = role.role;
            return acc;
          } else {
            return acc;
          }
        } else {
          acc.push(role);
          return acc;
        }
      }, []),
  };
};

export const initializeFoundation = () => async dispatch => {
  try {
    const user = await fetchCookieUser();
    if (user.roles.length === 0) {
      dispatch(tokenDuck.creators.setInvalidRoles());
      return;
    }
    const organization = mapOrganization(user);
    dispatch(userCreators.fetchSuccess(user));
    const token = 'dummyToken';
    dispatch(organizationCreators.fetchSuccess(organization));
    dispatch(getConfigurationAction(token));

    dispatch(tokenDuck.creators.setToken(token, 'refreshToken', createDateYearFromNow()));
  } catch (error) {
    return error;
  }
};

export const signoutZitadel = () => {
  globalThis.location.href = '/logout';
};
